import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Helpers } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import { ActivitySubscriptions, ActivitySubscriptionUpdateData } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public loadActivitySubscriptions(): Observable<ActivitySubscriptions> {
    return this.httpApi
      .get('/tracking/activity_subscriptions', null, null)
      .pipe(map(data => data.activitySubscriptions));
  }

  public updateActivitySubscription(
    payload: ActivitySubscriptionUpdateData,
  ): Observable<ActivitySubscriptions> {
    return this.httpApi.patch(
      '/tracking/activity_subscriptions/update_activity_subscriptions',
      null,
      {
        type: payload.type,
        value: payload.value,
        events: payload.events.map(Helpers.underscore),
      },
    );
  }

  public resetToDefaultActivitySubscriptionPerRole(): Observable<ActivitySubscriptions> {
    return this.httpApi
      .patch('/tracking/activity_subscriptions/reset_to_defaults', null, null)
      .pipe(map(data => data.activitySubscriptions));
  }
}
